// GENERATED by atsume-cms/scripts/generate-catalog-replica-config.mts — DO NOT EDIT.
// Source: atsume-cms/schema.graphql (single source shared with the server's
// catalog-replica-config.generated.ts). Regenerate from atsume-cms:
//   npm run generate-catalog-config

export type ReplicaColumnType = 'text' | 'int' | 'numeric' | 'bool';

export type ReplicaColumn = { field: string; col: string; type: ReplicaColumnType; fk?: boolean };

export type EntityReplicaConfig = {
  entity: string;
  field: string;
  table: string;
  version: number;
  columns: readonly ReplicaColumn[];
  indexes: readonly (readonly string[])[];
};

export const ENTITY_REPLICA_CONFIGS = [
  {
    "entity": "Novelty",
    "field": "novelties",
    "table": "novelty",
    "version": 3969259239,
    "columns": [
      {
        "field": "id",
        "col": "id",
        "type": "text"
      },
      {
        "field": "entryId",
        "col": "entryId",
        "type": "text"
      },
      {
        "field": "publisherName",
        "col": "publisherName",
        "type": "text"
      },
      {
        "field": "type",
        "col": "type",
        "type": "text"
      },
      {
        "field": "localizedSeriesTitle",
        "col": "localizedSeriesTitle",
        "type": "text"
      },
      {
        "field": "romanizedSeriesTitle",
        "col": "romanizedSeriesTitle",
        "type": "text"
      },
      {
        "field": "releaseDateAccuracy",
        "col": "releaseDateAccuracy",
        "type": "text"
      },
      {
        "field": "releaseDate",
        "col": "releaseDate",
        "type": "text"
      },
      {
        "field": "releaseYear",
        "col": "releaseYear",
        "type": "int"
      },
      {
        "field": "releaseMonth",
        "col": "releaseMonth",
        "type": "int"
      },
      {
        "field": "cover",
        "col": "cover",
        "type": "text"
      },
      {
        "field": "thumbHash",
        "col": "thumbHash",
        "type": "text"
      },
      {
        "field": "isbn",
        "col": "isbn",
        "type": "text"
      },
      {
        "field": "volumeSuffix",
        "col": "volumeSuffix",
        "type": "text"
      },
      {
        "field": "number",
        "col": "number",
        "type": "numeric"
      },
      {
        "field": "price",
        "col": "price",
        "type": "numeric"
      },
      {
        "field": "relationId",
        "col": "relationId",
        "type": "text"
      },
      {
        "field": "relationType",
        "col": "relationType",
        "type": "text"
      },
      {
        "field": "disabled",
        "col": "disabled",
        "type": "bool"
      },
      {
        "field": "tagSearchField",
        "col": "tagSearchField",
        "type": "text"
      },
      {
        "field": "demographySearchField",
        "col": "demographySearchField",
        "type": "text"
      },
      {
        "field": "titleSearch",
        "col": "titleSearch",
        "type": "text"
      }
    ],
    "indexes": [
      [
        "entryId"
      ],
      [
        "publisherName"
      ],
      [
        "type"
      ],
      [
        "localizedSeriesTitle"
      ],
      [
        "romanizedSeriesTitle"
      ],
      [
        "releaseDateAccuracy"
      ],
      [
        "releaseDate"
      ],
      [
        "releaseYear"
      ],
      [
        "releaseMonth"
      ],
      [
        "cover"
      ],
      [
        "thumbHash"
      ],
      [
        "isbn"
      ],
      [
        "volumeSuffix"
      ],
      [
        "number"
      ],
      [
        "price"
      ],
      [
        "relationId"
      ],
      [
        "relationType"
      ],
      [
        "disabled"
      ],
      [
        "tagSearchField"
      ],
      [
        "demographySearchField"
      ],
      [
        "titleSearch"
      ]
    ]
  },
  {
    "entity": "ReleaseEntry",
    "field": "releaseEntries",
    "table": "release_entry",
    "version": 2170115287,
    "columns": [
      {
        "field": "id",
        "col": "id",
        "type": "text"
      },
      {
        "field": "internalName",
        "col": "internalName",
        "type": "text"
      },
      {
        "field": "disabled",
        "col": "disabled",
        "type": "bool"
      },
      {
        "field": "status",
        "col": "status",
        "type": "text"
      },
      {
        "field": "cover",
        "col": "cover",
        "type": "text"
      },
      {
        "field": "thumbHash",
        "col": "thumbHash",
        "type": "text"
      },
      {
        "field": "endDate",
        "col": "endDate",
        "type": "text"
      },
      {
        "field": "startDate",
        "col": "startDate",
        "type": "text"
      },
      {
        "field": "releaseYear",
        "col": "releaseYear",
        "type": "int"
      },
      {
        "field": "releaseMonth",
        "col": "releaseMonth",
        "type": "int"
      },
      {
        "field": "yearMonthKey",
        "col": "yearMonthKey",
        "type": "text"
      },
      {
        "field": "popularityScore",
        "col": "popularityScore",
        "type": "numeric"
      },
      {
        "field": "recommendationScore",
        "col": "recommendationScore",
        "type": "numeric"
      },
      {
        "field": "firstVolumeNumber",
        "col": "firstVolumeNumber",
        "type": "numeric"
      },
      {
        "field": "totalVolumes",
        "col": "totalVolumes",
        "type": "int"
      },
      {
        "field": "totalNotReleasedVolumes",
        "col": "totalNotReleasedVolumes",
        "type": "int"
      },
      {
        "field": "totalReleasedVolumes",
        "col": "totalReleasedVolumes",
        "type": "int"
      },
      {
        "field": "publisherName",
        "col": "publisherName",
        "type": "text"
      },
      {
        "field": "type",
        "col": "type",
        "type": "text"
      },
      {
        "field": "creationDate",
        "col": "creationDate",
        "type": "text"
      },
      {
        "field": "updatedDate",
        "col": "updatedDate",
        "type": "text"
      },
      {
        "field": "needsToBeCheckedReason",
        "col": "needsToBeCheckedReason",
        "type": "text"
      },
      {
        "field": "tagSearchField",
        "col": "tagSearchField",
        "type": "text"
      },
      {
        "field": "demographySearchField",
        "col": "demographySearchField",
        "type": "text"
      },
      {
        "field": "titleSearch",
        "col": "titleSearch",
        "type": "text"
      }
    ],
    "indexes": [
      [
        "internalName"
      ],
      [
        "disabled"
      ],
      [
        "status"
      ],
      [
        "cover"
      ],
      [
        "thumbHash"
      ],
      [
        "endDate"
      ],
      [
        "startDate"
      ],
      [
        "releaseYear"
      ],
      [
        "releaseMonth"
      ],
      [
        "yearMonthKey"
      ],
      [
        "popularityScore"
      ],
      [
        "recommendationScore"
      ],
      [
        "firstVolumeNumber"
      ],
      [
        "totalVolumes"
      ],
      [
        "totalNotReleasedVolumes"
      ],
      [
        "totalReleasedVolumes"
      ],
      [
        "publisherName"
      ],
      [
        "type"
      ],
      [
        "creationDate"
      ],
      [
        "updatedDate"
      ],
      [
        "needsToBeCheckedReason"
      ],
      [
        "tagSearchField"
      ],
      [
        "demographySearchField"
      ],
      [
        "titleSearch"
      ]
    ]
  },
  {
    "entity": "ReleaseItem",
    "field": "releaseItems",
    "table": "release_item",
    "version": 3847300458,
    "columns": [
      {
        "field": "id",
        "col": "id",
        "type": "text"
      },
      {
        "field": "disabled",
        "col": "disabled",
        "type": "bool"
      },
      {
        "field": "disableNovelty",
        "col": "disableNovelty",
        "type": "bool"
      },
      {
        "field": "entryId",
        "col": "entryId",
        "type": "text"
      },
      {
        "field": "publisherName",
        "col": "publisherName",
        "type": "text"
      },
      {
        "field": "type",
        "col": "type",
        "type": "text"
      },
      {
        "field": "localizedSeriesTitle",
        "col": "localizedSeriesTitle",
        "type": "text"
      },
      {
        "field": "romanizedSeriesTitle",
        "col": "romanizedSeriesTitle",
        "type": "text"
      },
      {
        "field": "volumeSuffix",
        "col": "volumeSuffix",
        "type": "text"
      },
      {
        "field": "cover",
        "col": "cover",
        "type": "text"
      },
      {
        "field": "originalCover",
        "col": "originalCover",
        "type": "text"
      },
      {
        "field": "thumbHash",
        "col": "thumbHash",
        "type": "text"
      },
      {
        "field": "number",
        "col": "number",
        "type": "numeric"
      },
      {
        "field": "title",
        "col": "title",
        "type": "text"
      },
      {
        "field": "isbn",
        "col": "isbn",
        "type": "text"
      },
      {
        "field": "originalIsbn",
        "col": "originalIsbn",
        "type": "text"
      },
      {
        "field": "releaseDateAccuracy",
        "col": "releaseDateAccuracy",
        "type": "text"
      },
      {
        "field": "releaseDate",
        "col": "releaseDate",
        "type": "text"
      },
      {
        "field": "releaseYear",
        "col": "releaseYear",
        "type": "int"
      },
      {
        "field": "releaseMonth",
        "col": "releaseMonth",
        "type": "int"
      },
      {
        "field": "yearMonthKey",
        "col": "yearMonthKey",
        "type": "text"
      },
      {
        "field": "extrasOnlyOnFirstEdition",
        "col": "extrasOnlyOnFirstEdition",
        "type": "bool"
      },
      {
        "field": "price",
        "col": "price",
        "type": "numeric"
      },
      {
        "field": "creationDate",
        "col": "creationDate",
        "type": "text"
      },
      {
        "field": "updatedDate",
        "col": "updatedDate",
        "type": "text"
      },
      {
        "field": "needsToBeCheckedReason",
        "col": "needsToBeCheckedReason",
        "type": "text"
      },
      {
        "field": "extrasNote",
        "col": "extrasNote",
        "type": "text"
      },
      {
        "field": "notes",
        "col": "notes",
        "type": "text"
      },
      {
        "field": "pages",
        "col": "pages",
        "type": "int"
      },
      {
        "field": "format",
        "col": "format",
        "type": "text"
      },
      {
        "field": "currentEditionNumber",
        "col": "currentEditionNumber",
        "type": "int"
      },
      {
        "field": "color",
        "col": "color",
        "type": "text"
      },
      {
        "field": "size",
        "col": "size",
        "type": "text"
      },
      {
        "field": "tagSearchField",
        "col": "tagSearchField",
        "type": "text"
      }
    ],
    "indexes": [
      [
        "disabled"
      ],
      [
        "disableNovelty"
      ],
      [
        "entryId"
      ],
      [
        "publisherName"
      ],
      [
        "type"
      ],
      [
        "localizedSeriesTitle"
      ],
      [
        "romanizedSeriesTitle"
      ],
      [
        "volumeSuffix"
      ],
      [
        "cover"
      ],
      [
        "originalCover"
      ],
      [
        "thumbHash"
      ],
      [
        "number"
      ],
      [
        "title"
      ],
      [
        "isbn"
      ],
      [
        "originalIsbn"
      ],
      [
        "releaseDateAccuracy"
      ],
      [
        "releaseDate"
      ],
      [
        "releaseYear"
      ],
      [
        "releaseMonth"
      ],
      [
        "yearMonthKey"
      ],
      [
        "extrasOnlyOnFirstEdition"
      ],
      [
        "price"
      ],
      [
        "creationDate"
      ],
      [
        "updatedDate"
      ],
      [
        "needsToBeCheckedReason"
      ],
      [
        "extrasNote"
      ],
      [
        "notes"
      ],
      [
        "pages"
      ],
      [
        "format"
      ],
      [
        "currentEditionNumber"
      ],
      [
        "color"
      ],
      [
        "size"
      ],
      [
        "tagSearchField"
      ],
      [
        "entryId",
        "number"
      ]
    ]
  },
  {
    "entity": "ReleaseItemCollection",
    "field": "releaseItemCollections",
    "table": "release_item_collection",
    "version": 2230913248,
    "columns": [
      {
        "field": "id",
        "col": "id",
        "type": "text"
      },
      {
        "field": "name",
        "col": "name",
        "type": "text"
      },
      {
        "field": "cover",
        "col": "cover",
        "type": "text"
      },
      {
        "field": "thumbHash",
        "col": "thumbHash",
        "type": "text"
      },
      {
        "field": "entryId",
        "col": "entryId",
        "type": "text"
      },
      {
        "field": "publisherName",
        "col": "publisherName",
        "type": "text"
      },
      {
        "field": "type",
        "col": "type",
        "type": "text"
      },
      {
        "field": "localizedSeriesTitle",
        "col": "localizedSeriesTitle",
        "type": "text"
      },
      {
        "field": "romanizedSeriesTitle",
        "col": "romanizedSeriesTitle",
        "type": "text"
      },
      {
        "field": "disabled",
        "col": "disabled",
        "type": "bool"
      },
      {
        "field": "itemsOnlyExistInThisCollection",
        "col": "itemsOnlyExistInThisCollection",
        "type": "bool"
      },
      {
        "field": "volumeSuffix",
        "col": "volumeSuffix",
        "type": "text"
      },
      {
        "field": "number",
        "col": "number",
        "type": "numeric"
      },
      {
        "field": "isbn",
        "col": "isbn",
        "type": "text"
      },
      {
        "field": "releaseDateAccuracy",
        "col": "releaseDateAccuracy",
        "type": "text"
      },
      {
        "field": "releaseDate",
        "col": "releaseDate",
        "type": "text"
      },
      {
        "field": "releaseYear",
        "col": "releaseYear",
        "type": "int"
      },
      {
        "field": "releaseMonth",
        "col": "releaseMonth",
        "type": "int"
      },
      {
        "field": "price",
        "col": "price",
        "type": "numeric"
      },
      {
        "field": "extrasNote",
        "col": "extrasNote",
        "type": "text"
      },
      {
        "field": "notes",
        "col": "notes",
        "type": "text"
      },
      {
        "field": "pages",
        "col": "pages",
        "type": "int"
      },
      {
        "field": "format",
        "col": "format",
        "type": "text"
      },
      {
        "field": "currentEditionNumber",
        "col": "currentEditionNumber",
        "type": "int"
      },
      {
        "field": "color",
        "col": "color",
        "type": "text"
      },
      {
        "field": "size",
        "col": "size",
        "type": "text"
      },
      {
        "field": "tagSearchField",
        "col": "tagSearchField",
        "type": "text"
      }
    ],
    "indexes": [
      [
        "name"
      ],
      [
        "cover"
      ],
      [
        "thumbHash"
      ],
      [
        "entryId"
      ],
      [
        "publisherName"
      ],
      [
        "type"
      ],
      [
        "localizedSeriesTitle"
      ],
      [
        "romanizedSeriesTitle"
      ],
      [
        "disabled"
      ],
      [
        "itemsOnlyExistInThisCollection"
      ],
      [
        "volumeSuffix"
      ],
      [
        "number"
      ],
      [
        "isbn"
      ],
      [
        "releaseDateAccuracy"
      ],
      [
        "releaseDate"
      ],
      [
        "releaseYear"
      ],
      [
        "releaseMonth"
      ],
      [
        "price"
      ],
      [
        "extrasNote"
      ],
      [
        "notes"
      ],
      [
        "pages"
      ],
      [
        "format"
      ],
      [
        "currentEditionNumber"
      ],
      [
        "color"
      ],
      [
        "size"
      ],
      [
        "tagSearchField"
      ]
    ]
  },
  {
    "entity": "Publisher",
    "field": "publishers",
    "table": "publisher",
    "version": 409426299,
    "columns": [
      {
        "field": "id",
        "col": "id",
        "type": "text"
      },
      {
        "field": "name",
        "col": "name",
        "type": "text"
      },
      {
        "field": "disabled",
        "col": "disabled",
        "type": "bool"
      },
      {
        "field": "sortOrder",
        "col": "sortOrder",
        "type": "int"
      },
      {
        "field": "url",
        "col": "url",
        "type": "text"
      },
      {
        "field": "vlbId",
        "col": "vlbId",
        "type": "text"
      },
      {
        "field": "vlbKeyword",
        "col": "vlbKeyword",
        "type": "text"
      },
      {
        "field": "vlbSubjectFilter",
        "col": "vlbSubjectFilter",
        "type": "text"
      },
      {
        "field": "vlbTitleFilter",
        "col": "vlbTitleFilter",
        "type": "text"
      },
      {
        "field": "colorLightTheme",
        "col": "colorLightTheme",
        "type": "text"
      },
      {
        "field": "colorDarkTheme",
        "col": "colorDarkTheme",
        "type": "text"
      },
      {
        "field": "longName",
        "col": "longName",
        "type": "text"
      },
      {
        "field": "lastUpdateRun",
        "col": "lastUpdateRun",
        "type": "text"
      },
      {
        "field": "defaultVlbTextTypeCodes",
        "col": "defaultVlbTextTypeCodes",
        "type": "text"
      },
      {
        "field": "connector",
        "col": "connector",
        "type": "text"
      },
      {
        "field": "betterCoverProvider",
        "col": "betterCoverProvider",
        "type": "text"
      }
    ],
    "indexes": [
      [
        "name"
      ],
      [
        "disabled"
      ],
      [
        "sortOrder"
      ],
      [
        "url"
      ],
      [
        "vlbId"
      ],
      [
        "vlbKeyword"
      ],
      [
        "vlbSubjectFilter"
      ],
      [
        "vlbTitleFilter"
      ],
      [
        "colorLightTheme"
      ],
      [
        "colorDarkTheme"
      ],
      [
        "longName"
      ],
      [
        "lastUpdateRun"
      ],
      [
        "defaultVlbTextTypeCodes"
      ],
      [
        "connector"
      ],
      [
        "betterCoverProvider"
      ]
    ]
  },
  {
    "entity": "Tag",
    "field": "tags",
    "table": "tag",
    "version": 1083151467,
    "columns": [
      {
        "field": "id",
        "col": "id",
        "type": "text"
      },
      {
        "field": "name",
        "col": "name",
        "type": "text"
      },
      {
        "field": "sortNumber",
        "col": "sortNumber",
        "type": "int"
      },
      {
        "field": "tagType",
        "col": "tagType",
        "type": "text"
      },
      {
        "field": "promotionStartDate",
        "col": "promotionStartDate",
        "type": "text"
      },
      {
        "field": "promotionEndDate",
        "col": "promotionEndDate",
        "type": "text"
      }
    ],
    "indexes": [
      [
        "name"
      ],
      [
        "sortNumber"
      ],
      [
        "tagType"
      ],
      [
        "promotionStartDate"
      ],
      [
        "promotionEndDate"
      ]
    ]
  },
  {
    "entity": "Demography",
    "field": "demographies",
    "table": "demography",
    "version": 3102910893,
    "columns": [
      {
        "field": "id",
        "col": "id",
        "type": "text"
      },
      {
        "field": "name",
        "col": "name",
        "type": "text"
      }
    ],
    "indexes": [
      [
        "name"
      ]
    ]
  },
  {
    "entity": "VolumeSuffix",
    "field": "volumeSuffixes",
    "table": "volume_suffix",
    "version": 2584332824,
    "columns": [
      {
        "field": "id",
        "col": "id",
        "type": "text"
      },
      {
        "field": "name",
        "col": "name",
        "type": "text"
      },
      {
        "field": "abbreviation",
        "col": "abbreviation",
        "type": "text"
      }
    ],
    "indexes": [
      [
        "name"
      ],
      [
        "abbreviation"
      ]
    ]
  },
  {
    "entity": "SeriesInfo",
    "field": "seriesInfos",
    "table": "series_info",
    "version": 2784970480,
    "columns": [
      {
        "field": "id",
        "col": "id",
        "type": "text"
      },
      {
        "field": "country",
        "col": "country",
        "type": "text"
      },
      {
        "field": "originalTitle",
        "col": "originalTitle",
        "type": "text"
      },
      {
        "field": "romanizedTitle",
        "col": "romanizedTitle",
        "type": "text"
      },
      {
        "field": "type",
        "col": "type",
        "type": "text"
      },
      {
        "field": "status",
        "col": "status",
        "type": "text"
      },
      {
        "field": "startYear",
        "col": "startYear",
        "type": "text"
      }
    ],
    "indexes": [
      [
        "country"
      ],
      [
        "originalTitle"
      ],
      [
        "romanizedTitle"
      ],
      [
        "type"
      ],
      [
        "status"
      ],
      [
        "startYear"
      ]
    ]
  },
  {
    "entity": "StaffEntry",
    "field": "staffEntries",
    "table": "staff_entry",
    "version": 2854178065,
    "columns": [
      {
        "field": "id",
        "col": "id",
        "type": "text"
      },
      {
        "field": "originalVlb71Code",
        "col": "originalVlb71Code",
        "type": "text"
      }
    ],
    "indexes": [
      [
        "originalVlb71Code"
      ]
    ]
  },
  {
    "entity": "Individual",
    "field": "individuals",
    "table": "individual",
    "version": 1995989272,
    "columns": [
      {
        "field": "id",
        "col": "id",
        "type": "text"
      },
      {
        "field": "exId",
        "col": "exId",
        "type": "text"
      },
      {
        "field": "firstName",
        "col": "firstName",
        "type": "text"
      },
      {
        "field": "middleNames",
        "col": "middleNames",
        "type": "text"
      },
      {
        "field": "lastName",
        "col": "lastName",
        "type": "text"
      },
      {
        "field": "birthDate",
        "col": "birthDate",
        "type": "text"
      },
      {
        "field": "handle",
        "col": "handle",
        "type": "text"
      },
      {
        "field": "disambiguator",
        "col": "disambiguator",
        "type": "text"
      }
    ],
    "indexes": [
      [
        "exId"
      ],
      [
        "firstName"
      ],
      [
        "middleNames"
      ],
      [
        "lastName"
      ],
      [
        "birthDate"
      ],
      [
        "handle"
      ],
      [
        "disambiguator"
      ]
    ]
  },
  {
    "entity": "Job",
    "field": "jobs",
    "table": "job",
    "version": 1293886946,
    "columns": [
      {
        "field": "id",
        "col": "id",
        "type": "text"
      },
      {
        "field": "title",
        "col": "title",
        "type": "text"
      },
      {
        "field": "vlb71Codes",
        "col": "vlb71Codes",
        "type": "text"
      }
    ],
    "indexes": [
      [
        "title"
      ],
      [
        "vlb71Codes"
      ]
    ]
  },
  {
    "entity": "Magazine",
    "field": "magazines",
    "table": "magazine",
    "version": 3102910893,
    "columns": [
      {
        "field": "id",
        "col": "id",
        "type": "text"
      },
      {
        "field": "name",
        "col": "name",
        "type": "text"
      }
    ],
    "indexes": [
      [
        "name"
      ]
    ]
  },
  {
    "entity": "JpPublisher",
    "field": "jpPublishers",
    "table": "jp_publisher",
    "version": 3102910893,
    "columns": [
      {
        "field": "id",
        "col": "id",
        "type": "text"
      },
      {
        "field": "name",
        "col": "name",
        "type": "text"
      }
    ],
    "indexes": [
      [
        "name"
      ]
    ]
  },
  {
    "entity": "SizeInfo",
    "field": "sizeInfos",
    "table": "size_info",
    "version": 1357777530,
    "columns": [
      {
        "field": "id",
        "col": "id",
        "type": "text"
      },
      {
        "field": "sizeAliasName",
        "col": "sizeAliasName",
        "type": "text"
      },
      {
        "field": "width",
        "col": "width",
        "type": "numeric"
      },
      {
        "field": "height",
        "col": "height",
        "type": "numeric"
      },
      {
        "field": "depth",
        "col": "depth",
        "type": "numeric"
      }
    ],
    "indexes": [
      [
        "sizeAliasName"
      ],
      [
        "width"
      ],
      [
        "height"
      ],
      [
        "depth"
      ]
    ]
  },
  {
    "entity": "MaterialInfo",
    "field": "materialInfos",
    "table": "material_info",
    "version": 886231816,
    "columns": [
      {
        "field": "id",
        "col": "id",
        "type": "text"
      },
      {
        "field": "name",
        "col": "name",
        "type": "text"
      }
    ],
    "indexes": [
      [
        "name"
      ]
    ]
  },
  {
    "entity": "DatabaseListConfig",
    "field": "databaseListConfigs",
    "table": "database_list_config",
    "version": 1503534834,
    "columns": [
      {
        "field": "id",
        "col": "id",
        "type": "text"
      },
      {
        "field": "urlName",
        "col": "urlName",
        "type": "text"
      },
      {
        "field": "nameDe",
        "col": "nameDe",
        "type": "text"
      },
      {
        "field": "nameEn",
        "col": "nameEn",
        "type": "text"
      },
      {
        "field": "subtitleDe",
        "col": "subtitleDe",
        "type": "text"
      },
      {
        "field": "subtitleEn",
        "col": "subtitleEn",
        "type": "text"
      },
      {
        "field": "mode",
        "col": "mode",
        "type": "text"
      },
      {
        "field": "listType",
        "col": "listType",
        "type": "text"
      },
      {
        "field": "hideSearch",
        "col": "hideSearch",
        "type": "bool"
      },
      {
        "field": "enabled",
        "col": "enabled",
        "type": "bool"
      },
      {
        "field": "order",
        "col": "order",
        "type": "int"
      }
    ],
    "indexes": [
      [
        "urlName"
      ],
      [
        "nameDe"
      ],
      [
        "nameEn"
      ],
      [
        "subtitleDe"
      ],
      [
        "subtitleEn"
      ],
      [
        "mode"
      ],
      [
        "listType"
      ],
      [
        "hideSearch"
      ],
      [
        "enabled"
      ],
      [
        "order"
      ]
    ]
  },
  {
    "entity": "DatabaseListReleaseEntry",
    "field": "databaseListReleaseEntries",
    "table": "database_list_release_entry",
    "version": 680462940,
    "columns": [
      {
        "field": "id",
        "col": "id",
        "type": "text"
      },
      {
        "field": "orderNumber",
        "col": "orderNumber",
        "type": "int"
      },
      {
        "field": "compoundKey",
        "col": "compoundKey",
        "type": "text"
      },
      {
        "field": "databaseList",
        "col": "databaseList",
        "type": "text",
        "fk": true
      },
      {
        "field": "releaseEntry",
        "col": "releaseEntry",
        "type": "text",
        "fk": true
      }
    ],
    "indexes": [
      [
        "orderNumber"
      ],
      [
        "compoundKey"
      ],
      [
        "databaseList"
      ],
      [
        "releaseEntry"
      ]
    ]
  }
] as const satisfies readonly EntityReplicaConfig[];
